import { render, staticRenderFns } from "./NewsListingItem.vue?vue&type=template&id=318d4f20&scoped=true&"
import script from "./NewsListingItem.vue?vue&type=script&lang=js&"
export * from "./NewsListingItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsListingItem.vue?vue&type=style&index=0&id=318d4f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d4f20",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListingItem.vue
// module id = 354
// module chunks = 0